import { errorService } from './errorService'
import { userService } from './userService'
import { cleanResponseService } from './cleanResponseService'
import { labelService } from './labelService'
import { fliptService } from './fliptService'

export const services = {
  errorService,
  userService,
  cleanResponseService,
  labelService,
  fliptService
}



// WEBPACK FOOTER //
// ./src/services/index.js